module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "m-b-20 ovf-hd"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShow),
      expression: "addShow"
    }],
    staticClass: "fl"
  }, [_c('span', {
    staticClass: "btn-link-large add-btn",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("  发起流程\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "fl w-300 m-l-30",
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.search()
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    attrs: {
      "placeholder": "请输入关键词"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        _vm.keywords = $event
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl m-l-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "实例名称"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_c('router-link', {
          staticClass: "c-blue",
          attrs: {
            "to": {
              name: 'flowDetail',
              params: {
                id: scope.row.flow_id
              },
              query: {
                case_node_id: scope.row.case_node_id,
                case_id: scope.row.id
              }
            }
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.name) + "\n            ")])])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realname",
      "label": "创建人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "create_time",
      "label": "创建时间"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("parseTime")(scope.row.create_time)))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "case_status",
      "label": "流程状态"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.case_status))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.need_to_do == 1),
            expression: "scope.row.need_to_do == 1"
          }]
        }, [_c('router-link', {
          staticClass: "btn-link edit-btn m-r-5",
          attrs: {
            "to": {
              name: 'flowForm',
              params: {
                id: scope.row.flow_id
              },
              query: {
                case_node_id: scope.row.case_node_id,
                case_id: scope.row.id
              }
            }
          }
        }, [_vm._v("\n                处理\n              ")])]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          staticClass: "btn-link edit-btn m-r-5"
        }, [_vm._v("审批")])])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "need": "del",
      "type": "bpm/flowCases/deletes"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    attrs: {
      "title": "流程发起提示",
      "size": "tiny"
    },
    domProps: {
      "value": (_vm.dialogVisible)
    },
    on: {
      "input": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("是否发起一个流程？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createFlow
    }
  }, [_vm._v("确 定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b25b60c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/list.vue
// module id = 1828
// module chunks = 2